import React, { Component } from "react";
import { connect } from "react-redux";

import { 
    deactivateDeny, activateDeny, createDeny, updateDeny, getDenials 
} from "../../../../actions/DenyActions.js";

import { 
    getRoles
} from "../../../../actions/RolActions";

import { 
    DEACTIVATE_DENY, ACTIVATE_DENY, CREATE_DENY, UPDATE_DENY, GET_ERRORS, GET_DENIALS  
} from "../../../../actions/types";
import DenyModalComponent from "./DenyModalComponent";

import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import BootstrapTable from "react-bootstrap-table-next";
import LoadingOverlay from "react-loading-overlay";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button";
import MuiAlert from "@material-ui/lab/Alert";
import Dialog from "@material-ui/core/Dialog";
import Icon from "@material-ui/core/Icon";

function Alert(props) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class DenyComponent extends Component {

    state = {
        denies:                [],
        modalRolData:         null,
        textSnackBar:         "",
        modalType:            "CREATE",
		severitySnackBar:     "success",
        showDeactivateDialog: false,
        modalIsVisible:       false,
        showSnackBar:         false,
        activeLoader:         true,
        isActiveDeny:          true,
        selectedId:           0,
    }

    constructor(props) {
        super(props);
        this.handleCloseDeactivateDialog = this.handleCloseDeactivateDialog.bind(this);
        this.onPressDeactivate           = this.onPressDeactivate.bind(this);
        this.onPressCancel               = this.onPressCancel.bind(this);
		this.deactivateDeny               = this.deactivateDeny.bind(this);
        this.onCloseModal                = this.onCloseModal.bind(this);
        this.activateDeny                 = this.activateDeny.bind(this);
        this.handleClose                 = this.handleClose.bind(this);
		this.createDeny                   = this.createDeny.bind(this);
        this.updateDeny                   = this.updateDeny.bind(this);
        this.openModal                   = this.openModal.bind(this);
	}

    componentDidMount() {
		this.props.getDenials();
        this.props.getRoles();
	}

    componentDidUpdate(prevProps) {
		if (this.state.denies !== this.props.denies) {
			this.setState({
				denies: this.props.denies,
				activeLoader: false
			})
		}
        else if (this.props.actionType === CREATE_DENY && prevProps.actionType !== CREATE_DENY) {
			this.props.getDenials();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Deneagación creado exitosamente.",
				severitySnackBar: 'success',
			});
		}
        else if (this.props.actionType === UPDATE_DENY && prevProps.actionType !== UPDATE_DENY) {
			this.props.getDenials();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Deneagación actualizado exitosamente.",
				severitySnackBar: 'success',
			});
		}
        else if (this.props.actionType === ACTIVATE_DENY && prevProps.actionType !== ACTIVATE_DENY) {
			this.props.getDenials();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Deneagación activado exitosamente.",
				severitySnackBar: 'success',
			});
		}
        else if (this.props.actionType === DEACTIVATE_DENY && prevProps.actionType !== DEACTIVATE_DENY) {
			this.props.getDenials();
			this.setState({
				activeLoader: false,
				showSnackBar: true,
				textSnackBar: "Deneagación desactivado exitosamente.",
				severitySnackBar: 'success',
			});
		}
		else if (this.props.actionType === GET_ERRORS && prevProps.actionType !== GET_ERRORS) {
			this.setState({
				showSnackBar: true,
				textSnackBar: this.props.error,
				severitySnackBar: 'error',
			});
		}
    }

    ///---------------------------------------EVENTS-------------------------------------

    openModal = () => {
		this.setState({
			modalIsVisible: true,
			modalType: "CREATE",
		});
	};

    handleCloseDeactivateDialog = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		this.setState({
			showDeactivateDialog: false,
		});
	};

    createDeny(deny) {
        this.props.createDeny(deny);
		this.setState({
            activeLoader: true,
			modalIsVisible: false,
		})
	}

    updateDeny(deny) {
        this.props.updateDeny(deny);
		this.setState({
            activeLoader: true,
			modalIsVisible: false,
		})
    }
    
    activateDeny(id) {
        this.props.activateDeny(id);
        this.setState({
            showDeactivateDialog: false,
            modalIsVisible: false,
            selectedId: 0
        })
    }

    deactivateDeny() {
        this.props.deactivateDeny(this.state.selectedId);
        this.setState({
            showDeactivateDialog: false,
            modalIsVisible: false,
            selectedId: 0
        })
    }

    onPressDeactivate(id) {
        this.setState({
            showDeactivateDialog: true,
            modalIsVisible: false,
            selectedId: id,
            isActiveDeny: true
        });
	}


    onPressCancel() {
		this.setState({
			modalIsVisible: false,
			modalRolData: null
		})
		this.render();
	}

    onCloseModal() {
		this.setState({
			activeLoader: true,
			modalIsVisible: false,
			modalDenyData: null
		})
		this.render();
	}

    handleClose = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}

		this.setState({
			showSnackBar: false,
		});
	};

    ///---------------------------------------VIEW-------------------------------------

    render() {
        const rowEvents = {
            onClick: (e, row, rowIndex) => {
                this.setState({
                    modalType: "UPDATE",
                    modalDenyData: row,
                    modalIsVisible: true,
                });
            },
        };
        const columns = [
            {
                dataField: 'name',
                text: 'Nombre',
            },

            {
                dataField: 'description',
                text: 'Descripción',
                headerStyle: () => {
                    return { width: "40%" };
                }
            },

            {
                dataField: 'key',
                text: 'Clave',
            },
            {
                dataField: 'created_at',
                text: 'Fecha de creación',
                formatter: (cell) => cell ? new Date(cell).toLocaleDateString() : ""
            },
            {
                dataField: 'is_active',
                text: 'Estatus',
                formatter: (cell) => (cell ? "Activo" : "Inactivo"),
            },
        ];

        return ( 
             <center>
                <div className="toolbar end">
                    <Button
                        style={{
                            height: "10%",
                            backgroundColor: "#2ecc71",
                            padding: "0.8rem 0.8rem",
                            fontSize: "0.7rem",
                        }}
                        variant="contained"
                        color="primary"
                        startIcon={<Icon>add</Icon>}
                        onClick={this.openModal}
                    >
                      Agregar
                    </Button>
                </div>
                <div
                    style={{
                        textAlign: "left",
                        height: "1vh",
                        overflow: "auto",
                        width: "100%",
                        marginTop: "2vh",
                    }}
                >
                </div>
                {this.state.denies && this.state.denies.length > 0 &&
                    <BootstrapTable
                        keyField="_id"
                        key="8908290138209"
                        striped
                        hover
                        condensed
                        rowEvents={rowEvents}
                        data={this.state.denies}
                        headerWrapperClasses="title-table"
                        rowClasses="custom-row-table"
                        columns={columns}
                    />
                }
                {
                    this.state.denies &&
                    <DenyModalComponent
                        isVisible     = {this.state.modalIsVisible}
                        roles = {this.props.roles}
                        modalDenyData  = {this.state.modalDenyData}
                        deactivateDeny = {this.onPressDeactivate}
                        type          = {this.state.modalType}
                        activateDeny   = {this.activateDeny}
                        onPressCancel = {this.onPressCancel}
                        onCloseModal  = {this.onCloseModal}
                        createDeny     = {this.createDeny}
                        updateDeny     = {this.updateDeny}
                    />
                }
                {
                    <Dialog
                        open={this.state.showDeactivateDialog}
                        onClose={this.handleCloseDeactivateDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"Desactivar denegación"}
                        </DialogTitle>
                        <DialogContent>
                            { 
                                this.state.isActiveDeny &&
                                <DialogContentText id="alert-dialog-description">
                                    ¿Seguro que deseas desactivar la denegación?
                                </DialogContentText>
                            }
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={this.handleCloseDeactivateDialog}
                                color="secondary"
                            >
                                Cancelar
                            </Button>
                            {
                                this.state.isActiveDeny &&
                                <Button 
                                    onClick={this.deactivateDeny} 
                                    color="primary" autoFocus
                                >
                                    Desactivar
                                </Button>
                            }
                            {
                                this.state.isActiveDeny === false &&
                                <Button 
                                    onClick={this.activateDeny} 
                                    color="primary" autoFocus
                                >
                                    Activar
                                </Button>
                            }
                        </DialogActions>
                    </Dialog>
                }
                {
                    <LoadingOverlay
                        active={this.state.activeLoader}
                        isVisible={this.state.activeLoader}
                        spinner
                        text="Esto puede tardar unos minutos"
                        styles={{
                            wrapper: {
                                width: this.state.activeLoader ? "100%" : "0%",
                                height: this.state.activeLoader ? "100%" : "0%",
                                overflow: "hidden",
                            },
                            overlay: (base) => ({
                                ...base,
                                background: "rgba(10, 10, 10, 0.7)",
                            }),
                        }}
                    ></LoadingOverlay>
                }
                {
                    <Snackbar
                        open={this.state.showSnackBar}
                        autoHideDuration={6000}
                        onClose={this.handleClose}
                    >
                        <Alert
                            onClose={this.handleClose}
                            severity={this.state.severitySnackBar}
                        >
                            {this.state.textSnackBar}
                        </Alert>
                    </Snackbar>
                }
            </center>
      )
    }

}

const mapStateToProps = state => ({
    denies: state.deny_reducer.denies,
    roles: state.rol_reducer.roles,
    actionType: state.deny_reducer.actionType,
    error: state.deny_reducer.error,
	success: state.success,
});

export default connect(
     mapStateToProps, {
        deactivateDeny,
		activateDeny,
		createDeny,
		updateDeny,
		getDenials,
        getRoles
    }
)(DenyComponent);